import React from "react";
import PropTypes from "prop-types";
import { IconButton, makeStyles } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Close";

const styles = makeStyles((theme) => ({
  iconRoot: {
    cursor: "pointer",
    "&:hover": {
      background: "transparent !important",
      backgroundColor: "transparent !important",
    },
  },
  root: {
    color: theme.palette.primary.main,
    cursor: "pointer",
    "&:hover": {
      background: "transparent !important",
      backgroundColor: "transparent !important",
    },
  },
}));

const RemoveButton = (props) => {
  const classes = styles();
  return (
    <IconButton
      aria-label="delete"
      {...props}
      className={`${classes.iconRoot}`}
    >
      <DeleteIcon {...props} className={`${classes.root}${props.className}`} />
    </IconButton>
  );
};

RemoveButton.propTypes = {
  className: PropTypes.any,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default RemoveButton;
